module.exports = __webpack_public_path__ + "img/icon_sample.5cf6543f.svg";